import {
  generateUtilityClass,
  generateUtilityClasses,
  unstable_composeClasses as composeClasses,
  useMediaQuery,
  useTheme,
} from '@mui/material';

import { FieldListProps } from './FieldList';
import type { FieldListItemProps } from './Item/Item';

function getFieldListUtilityClass(slot: string) {
  return generateUtilityClass('O2FieldList', slot);
}

const fieldListClasses = generateUtilityClasses('O2FieldList', [
  'root',
  'item',
  'vertical',
  'horizontal',
  'cell',
  'label',
  'value',
]);

export default fieldListClasses;

export const useFieldListUtilityClasses = (classes: FieldListProps['classes']) => {
  const slots = {
    root: ['root'],
    item: ['item'],
    cell: ['cell'],
    label: ['label'],
    value: ['value'],
  };

  const composedClasses = composeClasses(slots, getFieldListUtilityClass, classes);

  return {
    ...classes,
    ...composedClasses,
  };
};

const getOrientation = (
  orientationProp: FieldListItemProps['orientation'],
  xsUp: boolean,
  smUp: boolean,
  mdUp: boolean,
  lgUp: boolean,
  xlUp: boolean
) => {
  if (!orientationProp || typeof orientationProp === 'string') {
    return orientationProp as string | undefined;
  }

  if (orientationProp['xl'] && xlUp) return orientationProp['xl'];

  if (orientationProp['lg'] && lgUp) return orientationProp['lg'];

  if (orientationProp['md'] && mdUp) return orientationProp['md'];

  if (orientationProp['sm'] && smUp) return orientationProp['sm'];

  if (orientationProp['xs'] && xsUp) return orientationProp['xs'];
};

export const useFieldListItemUtilityClasses = ({
  classes,
  orientation,
}: Pick<FieldListItemProps, 'classes' | 'orientation'>) => {
  const theme = useTheme();

  const xsUp = useMediaQuery(theme.breakpoints.up('xs'));
  const smUp = useMediaQuery(theme.breakpoints.up('sm'));
  const mdUp = useMediaQuery(theme.breakpoints.up('md'));
  const lgUp = useMediaQuery(theme.breakpoints.up('lg'));
  const xlUp = useMediaQuery(theme.breakpoints.up('xl'));

  const currentOrientation = getOrientation(orientation, xsUp, smUp, mdUp, lgUp, xlUp);

  const slots = {
    item: ['item', currentOrientation?.match('column') && 'vertical', currentOrientation?.match('row') && 'horizontal'],
    cell: ['cell'],
    label: ['label'],
    value: ['value'],
  };

  const composedClasses = composeClasses(slots, getFieldListUtilityClass, classes);

  return {
    ...classes,
    ...composedClasses,
  };
};
